//
//
//
//
//
//
//
//
//
//

import { SHARE, push } from '@/lib/gtm'
import { UAParser } from 'ua-parser-js'

export default {
  props: {
    link: {
      type: String,
      required: true
    },
    showToast: {
      type: Boolean,
      default: true,
    },
    showCopied: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isShareAvailable: navigator.share,
      copied: false,
    }
  },
  created () {
    const ua = new UAParser()
    this.mobileDevice = ua.getDevice().type === 'mobile' || ua.getDevice().type === 'tablet'
  },
  methods: {
    shareLink () {
      try {
        navigator.share({
          url: this.link,
        })
        push(SHARE.NATIVE, {
          shareUrl: this.link,
          title: this.title,
          text: this.text,
        })
        this.$emit('share')
      } catch (e) {
        // they probably cancelled the share
        this.$logger.error(e)
      }
    },
    linkCopied () {
      push(SHARE.COPY, {
        shareUrl: this.link
      })
      this.$emit('copy')
      if (this.showToast) {
        this.$toast.success('Link Copied!')
      }
      if (this.showCopied) {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 3000)
      }
    },
  }
}
